import { defineAction } from '~/prix'
import deleteQuestionnaireAction from './questionnaireDelete.action.json' with { type: 'json' }
import { z } from 'zod'

const deleteQuestionnaireDefinition = defineAction({
  ...deleteQuestionnaireAction,
  input: z.object({
    id: z.coerce.number().describe('Identificador'),
  }),
  output: z.object({}),
})

export default deleteQuestionnaireDefinition
